import AbstractServiceNavigationBehaviour from './abstract-service-navigation-behaviour';

export default class ExpandBottomBehaviour extends AbstractServiceNavigationBehaviour {
    /**
     * @return {boolean}
     */
    shouldExpand() {
        return (e => e.scrollHeight - e.scrollTop <= e.clientHeight + 50)(document.documentElement);
    }
}